module.exports = __webpack_public_path__ + "img/desc-1.1.1dc662d2.jpg";